import Breadcrumb from '../../layout/breadcrumb';
import React, { useState, useEffect, Fragment } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader, Button, Badge } from 'reactstrap';

import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import { Globe } from 'react-feather';

import 'react-vertical-timeline-component/style.min.css';

import SweetAlert from 'sweetalert2';

import { useGlobalState } from 'state-pool';

import { ASSETS_CDN } from '../../constant/config';
import { planet_name } from '../../constant/names';
import { Information } from '../utils/Information';

const Mine = (props) => {
  const [videoAnimation] = useGlobalState('animateVideo');
  const [web3, setWeb3] = useGlobalState('Web3');

  const [userAddress, setUserAddress] = useGlobalState('userAddress');

  const [stoneContract, setStoneContract] = useGlobalState('stoneContract');
  const [stoneAmount, setStoneAmount] = useGlobalState('stoneAmount');

  const [cryptominesContract, setCryptominesContract] = useGlobalState('cryptominesContract');
  const [minePower, setMinePower] = useGlobalState('MinePower');
  const [claimRewards, setClaimRewards] = useGlobalState('claimRewards');

  const [workerAmount, setWorkerAmount] = useGlobalState('workerAmount');
  const [maxWorkers, setMaxWorkers] = useGlobalState('maxWorkers');
  const [spaceshipAmount, setSpaceshipAmount] = useGlobalState('spaceshipAmount');

  const [maxMineLevel, setMaxMineLevel] = useState(0);

  const [minDifficulty, setMinDifficulty] = useState(0);
  const [mpRequiredPerMine, setMpRequiredPerMine] = useState(0);
  const [mineSuccesRate, setMineSuccesRate] = useState([]);
  const [baseMineSuccesRate, setBaseMineSuccesRate] = useState([]);
  const [bonusSuccesRate, setBonusSuccesRate] = useState([]);
  const [mineRewards, setMineRewards] = useState([]);

  const [loaded, setLoaded] = useState(0);
  const [toggleInformation, setToggleInformation] = useState(false);
  const [mines] = useState([
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  ]);

  const [claimTax, setClaimTax] = useGlobalState('claimTax');

  useEffect(() => {
    async function initializeMine() {
      const currentMinePower = await cryptominesContract.methods.getMinePower().call({ from: userAddress });
      const currentMinDifficulty = await cryptominesContract.methods.getMinDifficulty().call({ from: userAddress });
      const currentMpRequiredPerMine = await cryptominesContract.methods
        .getMpRequiredPerMine()
        .call({ from: userAddress });

      const currentMineRewardEternal = parseFloat(
        web3.utils.fromWei(
          await cryptominesContract.methods.getMineRewardEternal().call({ from: userAddress }),
          'ether'
        )
      );

      const currentMineRewards = [];
      mines.forEach(async (level) => {
        let levelMineReward = 5;
        if (level == 1) {
          levelMineReward = currentMineRewardEternal * level;
        }
        if (level >= 2 && level <= 10) {
          levelMineReward =
            currentMineRewardEternal + (level - 1) * currentMineRewardEternal * Math.pow(1.02, level - 1);
        }
        if (level >= 11 && level <= 20) {
          levelMineReward =
            currentMineRewardEternal + (level - 1) * currentMineRewardEternal * Math.pow(1.03, level - 1);
        }
        if (level >= 21 && level <= 30) {
          levelMineReward =
            currentMineRewardEternal + (level - 1) * currentMineRewardEternal * Math.pow(1.04, level - 1);
        }

        currentMineRewards.push(Math.round(levelMineReward * 10) / 10);
      });
      setMineRewards(currentMineRewards);

      setMinePower(currentMinePower);
      setMinDifficulty(parseInt(currentMinDifficulty));
      setMpRequiredPerMine(parseInt(currentMpRequiredPerMine));
      reloadList();
    }

    if (cryptominesContract != null && loaded == 0) {
      initializeMine();
    }
  });

  const reloadList = async () => {
    let currentMinePower = await cryptominesContract.methods.getMinePower().call({ from: userAddress });
    const difficultyOfMine = 2;
    const minDifficulty = 90;
    let maxMineLevel = Math.floor(currentMinePower / mpRequiredPerMine);

    if (maxMineLevel > 30) {
      maxMineLevel = 30;
    }

    var successRates = [];
    var bonusSuccess = [];
    var baseSuccess = [];

    mines.forEach((level) => {
      let bonusSuccessRate = 0;
      if (currentMinePower >= 1500) {
        const mpDiff = currentMinePower * 10 - mpRequiredPerMine * 10 * level;
        const steps = Math.floor(mpDiff / mpRequiredPerMine);
        bonusSuccessRate = steps * difficultyOfMine;
        if (bonusSuccessRate <= 0) {
          bonusSuccessRate = 0;
        }
      }
      let baseMineSuccess = parseInt(minDifficulty - level * difficultyOfMine);
      if (baseMineSuccess <= 50) {
        baseMineSuccess = 50;
      }
      let mineSuccess = Math.floor(baseMineSuccess + bonusSuccessRate / 10);
      //console.log("Level "+level+": "+baseMineSuccess)
      if (mineSuccess >= 88) {
        mineSuccess = 88;
      } else if (mineSuccess <= 50) {
        mineSuccess = 50;
      }

      let bonusDiff = mineSuccess - baseMineSuccess;
      //console.log("Level "+level+": "+mineSuccess)
      bonusSuccess.push(bonusDiff);
      successRates.push(mineSuccess);
      baseSuccess.push(baseMineSuccess);
    });

    setBonusSuccesRate(bonusSuccess);
    setMineSuccesRate(successRates);
    setBaseMineSuccesRate(baseSuccess);

    setMaxMineLevel(maxMineLevel);
    setLoaded(1);
  };

  const reloadData = async () => {
    const currentStones = await stoneContract.methods.balanceOf(userAddress).call({ from: userAddress });
    const currentMinePower = await cryptominesContract.methods.getMinePower().call({ from: userAddress });
    const currentClaimRewards = await cryptominesContract.methods
      .getTokenRewards(userAddress)
      .call({ from: userAddress });
    setStoneAmount(web3.utils.fromWei(currentStones, 'ether'));
    setMinePower(currentMinePower);
    setClaimRewards(web3.utils.fromWei(currentClaimRewards, 'ether'));
    reloadList();
  };

  const enterMine = async (mineLevel) => {
    if (parseInt(workerAmount) > parseInt(maxWorkers)) {
      SweetAlert.fire({
        title: 'Too many workers',
        text: 'You have more workers than your Spaceships can carry',
        icon: 'error',
      });
    } else if (parseInt(spaceshipAmount) > 10) {
      SweetAlert.fire({
        title: 'Too many Spaceships',
        text: 'You have more Spaceships than your garage can hold.',
        icon: 'error',
      });
    } else {
      await cryptominesContract.methods
        .goMine(mineLevel)
        .send({ from: userAddress })
        .once('transactionHash', function (hash) {
          SweetAlert.fire({
            title: 'Expedition started',
            text: 'Your workers started the expedition on planet: ' + planet_name[mineLevel],
            icon: 'info',
          });
        })
        .once('receipt', function (receipt) {})
        .on('confirmation', function (confNumber, receipt) {})
        .on('error', function (error) {})
        .then(function (receipt) {
          let roll = parseInt(receipt.events.eventGoMine.returnValues['roll']);
          let winChance = parseInt(receipt.events.eventGoMine.returnValues['winChance']);
          let reward = web3.utils.fromWei(receipt.events.eventGoMine.returnValues['reward'], 'ether');
          if (roll <= winChance) {
            SweetAlert.fire({
              title: 'Expedition Success',
              text: 'Your guild was rewarded ' + parseFloat(reward).toFixed(3) + ' ETERNAL.',
              footer:
                '<center><b>Success Rate</b><br><b>Your Roll:</b> ' +
                roll +
                ' 🎲 <br><b>To Win roll equal or less than: </b>' +
                winChance +
                ' 🏆 </center>',
              icon: 'success',
            });
          } else {
            SweetAlert.fire({
              title: 'Expedition failed',
              text: 'Workers encountered a problem on the planet, no rewards obtained.',
              footer:
                '<center><b>Success Rate</b><br><b>Your Roll:</b> ' +
                roll +
                ' 🎲 <br><b>To Win roll equal or less than: </b>' +
                winChance +
                ' 🏆 </center>',
              icon: 'error',
            });
          }
          window.gtag('event', 'goMine', { roll: roll, winchance: winChance, reward: reward, address: userAddress });
        });

      const currentClaimTime = await cryptominesContract.methods.getMyTimeForClaim().call({ from: userAddress });

      let now = parseInt((Date.now() / 1000).toFixed(0));
      let remainingDays = (((currentClaimTime - now) / 86400) * 2).toFixed(2);
      if (remainingDays <= 0) {
        remainingDays = 0;
      }
      setClaimTax(remainingDays);

      reloadData();
      setMaxMineLevel(0);
    }
  };

  return (
    <Fragment>
      <Breadcrumb parent='Mine' title='Mine' />
      <Container fluid={true}>
        <Row>
          <Col sm='12'>
            <Card className='card-absolute mine-card'>
              <CardHeader className='bg-danger'>
                <h3>Mine</h3>
                {/*  {/* <button
                  className='toggle-information btn btn-success'
                  onClick={() => setToggleInformation(!toggleInformation)}
                >
                  ?
                </button> */}
              </CardHeader>
              <CardBody>
                <Information section='mines' display={true} />
                <Row>
                  <Col sm='6'>
                    <Card className='o-hidden'>
                      <CardBody>
                        <center>
                          <p className='f-w-500 font-roboto f-26'>
                            <b>Current Mine Power</b>
                          </p>
                          <h4 className='f-w-500 mb-0 f-26'>
                            <span className='badge pill-badge-secondary ml-3'>{minePower} MP</span>
                          </h4>
                          <br />
                          <p>Based on workers that can enter the mine right now.</p>
                        </center>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col sm='6'>
                    <Card className='o-hidden'>
                      <CardBody>
                        <center>
                          <p className='f-w-500 font-roboto f-26'>
                            <b>Max Planet Level</b>
                          </p>
                          <h4 className='f-w-500 mb-0 f-26'>
                            <span className='badge pill-badge-warning ml-3'>Level {maxMineLevel}</span>
                          </h4>
                          <br />
                          <p>Based on your mine power available right now.</p>
                        </center>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                {maxMineLevel <= 0 && minePower <= 0 && (
                  <center>
                    <Col md='12'>
                      <Col sm='8'>
                        <Card className='o-hidden'>
                          <CardBody>
                            <center>
                              <p className='f-w-500 font-roboto f-26'>
                                <b>Your workers are exhausted or not hired.</b>
                              </p>
                              <div className='loader-box'>
                                <div className='loader-20'></div>
                              </div>
                              <p>Please wait 24 hours after your last mine or check your workers contracts.</p>
                            </center>
                          </CardBody>
                        </Card>
                      </Col>
                    </Col>
                  </center>
                )}

                {maxMineLevel <= 0 && minePower >= 1 && (
                  <center>
                    <Col md='12'>
                      <Col sm='6'>
                        <Card className='o-hidden'>
                          <CardBody>
                            <center>
                              <p className='f-w-500 font-roboto f-26'>
                                <b>Not enought Mine Power</b>
                              </p>
                              <p>
                                💡 Remember, the minimum expedition requires <b>{mpRequiredPerMine} MP</b>{' '}
                              </p>
                              <p>You can increase your Mine Power by getting more workers.</p>
                              <p>
                                Read more at:{' '}
                                <a href='https://docs.cryptomines.app/gameplay-1/workers' target='_blank'>
                                  https://docs.cryptomines.app/gameplay-1/workers
                                </a>
                              </p>
                            </center>
                          </CardBody>
                        </Card>
                      </Col>
                    </Col>
                  </center>
                )}

                <VerticalTimeline>
                  {mines
                    ? mines.map((mine, i) => (
                        <VerticalTimelineElement
                          iconStyle={{ color: '#fff', background: 'var(--theme-deafult)' }}
                          icon={<Globe />}
                          key={i}
                        >
                          <center>
                            <h4>{planet_name[mine]}</h4>
                            <p>
                              (Level: {mine}) ({mpRequiredPerMine * mine} MP Required)
                            </p>

                            {minePower >= 1500 && bonusSuccesRate[i] > 0 ? (
                              <Fragment>
                                <hr />
                                <Badge color='primary'>
                                  <h6>Bonus Success Rate (+{bonusSuccesRate[i]})</h6>
                                </Badge>
                              </Fragment>
                            ) : (
                              ''
                            )}

                            {minePower >= 1500 && bonusSuccesRate[i] > 0 ? (
                              <Fragment>
                                <hr />
                                <Col className='text-center'>
                                  <span>Base Success Rate</span>
                                  <h4 className='counter mb-0'>
                                    <del>{baseMineSuccesRate[i]}%</del>
                                  </h4>
                                </Col>
                              </Fragment>
                            ) : (
                              ''
                            )}

                            <hr />
                            <Row>
                              <Col className='text-center b-r-light'>
                                <span>Estimated Rewards</span>
                                <h4 className='counter mb-0'>{mineRewards[i]} ETERNAL </h4>
                              </Col>

                              <Col className='text-center'>
                                <span>Total Success Rate</span>
                                <h4 className='counter mb-0'>{mineSuccesRate[i]}%</h4>
                              </Col>
                            </Row>
                            <br />
                            {videoAnimation ? (
                              <video className='img-fluid' muted loop={videoAnimation} autoPlay={videoAnimation}>
                                <source src={`${ASSETS_CDN}/planets/${mine}.mp4`} type='video/mp4' />
                              </video>
                            ) : (
                              <img className='img-fluid' src={`${ASSETS_CDN}/planets/${mine}.png`} alt='Planet NFT' /> 
                            )}
                            

                            {maxMineLevel >= mine ? (
                              <Button
                                className='btn-pill btn-air-primary'
                                size='lg'
                                color='danger'
                                onClick={() => enterMine(mine)}
                              >
                                Mine this planet
                              </Button>
                            ) : (
                              <Button className='btn-pill btn-dark' size='lg' disabled>
                                Get more Mine Power
                              </Button>
                            )}
                          </center>
                        </VerticalTimelineElement>
                      ))
                    : ''}
                </VerticalTimeline>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Mine;
